import { render, staticRenderFns } from "./salesRecordExamine.vue?vue&type=template&id=e87dbfda&scoped=true"
import script from "./salesRecordExamine.vue?vue&type=script&lang=js"
export * from "./salesRecordExamine.vue?vue&type=script&lang=js"
import style0 from "./salesRecordExamine.vue?vue&type=style&index=0&id=e87dbfda&prod&scoped=true&lang=css"
import style1 from "./salesRecordExamine.vue?vue&type=style&index=1&id=e87dbfda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87dbfda",
  null
  
)

export default component.exports